export default __webpack_public_path__ + "static/media/36.af04007f.jpg";